import {
  startOfYesterday,
  endOfYesterday,
  startOfToday,
  endOfToday,
  startOfTomorrow,
  endOfTomorrow,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  startOfYear,
  endOfYear,
  subDays,
  subWeeks,
  subMonths,
  subQuarters,
  subYears,
  addDays,
  addWeeks,
  addMonths,
  startOfDay,
} from "date-fns";

const today = startOfDay(new Date());

export const PresetRanges = [
  { label: "yesterday", value: [startOfYesterday(), endOfYesterday()] },
  { label: "today", value: [startOfToday(), endOfToday()] },
  { label: "tomorrow", value: [startOfTomorrow(), endOfTomorrow()] },
  { label: "last_seven_days", value: [subDays(today, 7), today] },
  { label: "last_thirty_days", value: [subDays(today, 30), today] },
  { label: "next_seven_days", value: [today, addDays(today, 7)] },
  { label: "next_thirty_days", value: [today, addDays(today, 30)] },
  {
    label: "last_week",
    value: [startOfWeek(subWeeks(today, 1), { weekStartsOn: 1 }), endOfWeek(subWeeks(today, 1), { weekStartsOn: 1 })],
  },
  {
    label: "this_week",
    value: [startOfWeek(today, { weekStartsOn: 1 }), endOfWeek(today, { weekStartsOn: 1 })],
  },
  {
    label: "next_week",
    value: [startOfWeek(addWeeks(today, 1), { weekStartsOn: 1 }), endOfWeek(addWeeks(today, 1), { weekStartsOn: 1 })],
  },
  { label: "last_month", value: [startOfMonth(subMonths(today, 1)), endOfMonth(subMonths(today, 1))] },
  { label: "this_month", value: [startOfMonth(today), endOfMonth(today)] },
  { label: "next_month", value: [startOfMonth(addMonths(today, 1)), endOfMonth(addMonths(today, 1))] },
  {
    label: "last_quarter",
    value: [startOfQuarter(subQuarters(today, 1)), endOfQuarter(subQuarters(today, 1))],
  },
  { label: "this_quarter", value: [startOfQuarter(today), endOfQuarter(today)] },
  { label: "last_year", value: [startOfYear(subYears(today, 1)), endOfYear(subYears(today, 1))] },
  { label: "this_year", value: [startOfYear(today), endOfYear(today)] },
];

export const PresetMonthRanges = [
  { label: "last_year", value: [startOfYear(subYears(today, 1)), endOfYear(subYears(today, 1))] },
  { label: "this_year", value: [startOfYear(today), endOfYear(today)] },
];
